// extracted by mini-css-extract-plugin
export default {"icon":"icon--xNcZN","pause":"pause--GwmB8 icon--xNcZN","flag":"flag--M5YAk icon--xNcZN","hidden":"hidden--RwD1V icon--xNcZN"};